import { useCallback, useState } from 'react';

// Owned by the caller, not the grid: the Portfolio widget unmounts the grid while
// it refreshes, and the adviser's collapsed groups must survive that.
export const useCollapsedAssetGroups = () => {
  const [collapsedAssetGroups, setCollapsedAssetGroups] = useState(
    () => new Set<string>(),
  );

  const toggleAssetGroupCollapse = useCallback((assetClassId: string) => {
    setCollapsedAssetGroups((prev) => {
      const next = new Set(prev);
      if (next.has(assetClassId)) {
        next.delete(assetClassId);
      } else {
        next.add(assetClassId);
      }
      return next;
    });
  }, []);

  return { collapsedAssetGroups, toggleAssetGroupCollapse };
};
